import React from 'react';
import LegalPage from '../components/LegalPage';
import { DEFAULT_COOKIES } from '../lib/pageDefaults';

export default function CookiesPage() {
  return <LegalPage pageKey="cookies" defaults={DEFAULT_COOKIES} />;
}
